const initialState = {
    isCreating: false,
    invoiceBeingRead: null,
    invoice: null,
    invoiceError: false,
    invoiceBeingUpdated: null,
    invoicesCount: 0,
    isReadingInvoices: false,
    invoices: [],
    invoiceLogs: {},
    invoiceBeingReadForLogs: null
}

export default initialState;
